import { UI_STATE } from '@/config/ui-invariants';

export const runDOMProbe = () => {
    const probe = {
        timestamp: new Date().toISOString(),
        rootExists: !!document.getElementById('root'),
        rootChildCount: document.getElementById('root')?.childElementCount || 0,
        lifecycleComplete: window.__ACCREZEO_LIFECYCLE_COMPLETE__ || false,
        appErrorBoundaryMounted: !!document.querySelector('[data-error-boundary="true"]'), // Assumes we add this attr
        location: window.location.pathname,
        phase: UI_STATE.getPhase()
    };

    console.log('[RUNTIME_EVIDENCE_PROBE]', JSON.stringify(probe));
};

// Auto-run on load
setTimeout(runDOMProbe, 2000);
setTimeout(runDOMProbe, 5000);
